import { render, staticRenderFns } from "./AppCommunicationToolsOverview.vue?vue&type=template&id=e74dbd16&scoped=true&"
import script from "./AppCommunicationToolsOverview.vue?vue&type=script&lang=ts&"
export * from "./AppCommunicationToolsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AppCommunicationToolsOverview.vue?vue&type=style&index=0&id=e74dbd16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74dbd16",
  null
  
)

export default component.exports